"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Wrench, Truck, Package } from "lucide-react";
export default function OurServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const services = [{
    id: 1,
    icon: Wrench,
    title: "Equipment Leasing for Construction",
    description: "Access a comprehensive inventory of heavy machinery and tools through our partnerships with Sunbelt Rentals and United Rentals, ensuring your project has the right equipment at the right time.",
    delay: "animate-fade-in-up"
  }, {
    id: 2,
    icon: Truck,
    title: "Equipment Delivery",
    description: "Streamlined logistics service ensuring timely delivery of construction equipment directly to your job site, minimizing downtime and keeping your project on schedule.",
    delay: "animate-fade-in-up-delay-100"
  }, {
    id: 3,
    icon: Package,
    title: "Equipment Pickup",
    description: "Efficient equipment return service with coordinated pickup scheduling, handling all paperwork and logistics so you can focus on completing your construction projects.",
    delay: "animate-fade-in-up-delay-200"
  }];
  return <section id="our-services" className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive equipment solutions for the construction industry, backed by industry-leading partners.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map(service => {
          const IconComponent = service.icon;
          return <Card key={service.id} data-index={service.id - 1} className={`
                  border border-border shadow-soft
                  hover:shadow-medium hover:scale-[1.02]
                  transition-all duration-[100ms] ease-out
                  ${isVisible ? service.delay : "opacity-0"}
                `}>
                <CardHeader>
                  <div className="mb-4 flex items-center justify-center size-16 rounded-lg bg-primary/10">
                    <IconComponent className="size-8 text-primary" aria-hidden="true" />
                  </div>
                  <CardTitle className="text-xl font-display">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                  <Button asChild variant="outline" className="w-full hover:bg-primary hover:text-foreground-primary hover:border-primary transition-all duration-[100ms]">
                    <Link to="mailto:info@atandellc.com">Learn More</Link>
                  </Button>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}